module.exports = __webpack_public_path__ + "static/media/pov_whole_SmallStellatedDodecahedron.9a93b240.png";